
import * as firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyC4yyvAooYUCEFKSb8lgEUwezdE0oe0NhA",
  authDomain: "doyoubus-b764e.firebaseapp.com",
  databaseURL: "https://doyoubus-b764e.firebaseio.com",
  projectId: "doyoubus-b764e",
  storageBucket: "doyoubus-b764e.appspot.com",
  messagingSenderId: "262883532294",
  appId: "1:262883532294:web:670e774394155e92472d87"
};

const app=firebase.initializeApp(firebaseConfig);
 
export default app;